import { render, staticRenderFns } from "./reviewPreview.vue?vue&type=template&id=e87cbc6a&scoped=true"
import script from "./reviewPreview.vue?vue&type=script&lang=js"
export * from "./reviewPreview.vue?vue&type=script&lang=js"
import style0 from "./reviewPreview.vue?vue&type=style&index=0&id=e87cbc6a&prod&lang=scss&scoped=true"
import style1 from "./reviewPreview.vue?vue&type=style&index=1&id=e87cbc6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87cbc6a",
  null
  
)

export default component.exports